'use client';

export const BridgeEvent = {
  SetContext: 'set-context',
  InsightsTraceInformation: 'insights-trace-information',
  InsightsTraceWarning: 'insights-trace-warning',
  InsightsTraceError: 'insights-trace-error',
  InsightsTag: 'insights-tag',
  ReceiveData: 'receive-data',
  SendData: 'send-data',
};

export const NativeBridgeAvailable = typeof window !== 'undefined' && !!window?.ReactNativeWebView;
